import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the SES environment (`admin.ses.wisesys.info`)
 */
export const sesServerConfig: ServerBaseUrl = {
    apiServer: 'https://wise-api.ses.wisesys.info',
    auroraApiServer: 'https://uat.aurora-v2.wisesys.info',
    socketServer: 'wss://socket.ses.wisesys.info',
    environment: ServerEnvironment.SES,
    CIEnv: ServerCIEnvironment.SES,
    auroraServer: '',
    vehicleProfile:
        'https://z9fgl5xulh.execute-api.us-east-1.amazonaws.com/uat',
    routePathGeometryServer:
        'https://u0dlfowfi9.execute-api.us-east-1.amazonaws.com/uat',
    configurableWorkflowServer:
        'https://ksjgorzu2k.execute-api.us-east-1.amazonaws.com/Prod',
    driverCostServer: '' // TODO(CD-112): regional UAT — needs its own dcs-<region> stack (separate Cognito issuer)
};
